import { AxiosError } from 'axios';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { User } from '../auth';

export type ExpensesAction = ActionType<typeof actions>;

export interface ExpensesState {
  expenses: {
    data: Expense[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  // expense: {
  //   data: Expense | null;
  //   loading: boolean;
  //   error: AxiosError | null;
  // };
}

export interface ExpenseParams {
  enterpriseId: string;
  projectId?: string;
  expenseId?: string;
  expense?: any;
  filterData?: any;
  data?: any;
}

export enum ExpenseStatus {
  PROCESSING = '0',
  EDITING = '1',
  SUBMITTED = '2',
  DECLINED = '3',
  EXCLUDED = '4',
}

export const expenseStatusKorean = {
  '0': '처리중',
  '1': '입력중',
  '2': '제출완료',
  '3': '거절',
  '4': '제외',
} as const;

export enum InsertType {
  DIRECT_INPUT = '0',
  AUTO_RECOG = '1',
  WITH_ASSET_DATA = '2',
}

export enum AssetType {
  CARD = '0',
  ACCOUNT = '1',
  TAX = '2',
}

export enum CodefCardCancelYesNoStatus {
  OK = '0', // 정상
  CANCEL_ALL = '1', // 취소
  PARTIAL_CANCELLATION = '2', // 부분 취소
  REFUSAL = '3', // 거절
}

export interface Expense {
  id: number;
  price: number;
  vat: number;
  companyName: string;
  companyAddress: string;
  usedDateTime: string;
  category: string;
  gongjong: string;
  description: string;
  expenseStatus: ExpenseStatus;
  insertType: InsertType;
  cancelYesNo: CodefCardCancelYesNoStatus;
  isRefund: boolean;
  usedBy: any;
  project: any;
  file: any[];
  expenseHistories: any[];
  financialAssetInfo: any;
  assetData: any;
}

export interface ExpenseHistory {
  id: number;
  user: User;
  userData?: any;
  description: string;
  createdAt: string;
}
